import type { I18nActiveNamespaces } from '@/lib/i18n';

export type CheckoutConfig = {
  i18nNamespaces: I18nActiveNamespaces<
    'common' | 'checkout' | 'booking' | 'payment' | 'record' | 'system'
  >;
};

export const checkoutConfig: CheckoutConfig = {
  i18nNamespaces: [
    'common',
    'checkout',
    'booking',
    'payment',
    'record',
    'system',
  ],
};
